/* @flow */

import { logDebug } from '../debug/debug';

let lastTokenCheck = 0;
const TOKEN_CHECK_INTERVAL = 300_000; // 5 minutes in ms

type Options = {
  ensureFcmToken: () => Promise<string | null>,
};

const initializeFcmLifecycleManager = ({ ensureFcmToken }: Options): void => {
  // Initial check of cached FCM registration token
  ensureFcmToken();

  // Focus refresh (throttled)
  window.addEventListener('focus', () => {
    const now = Date.now();

    if (now - lastTokenCheck > TOKEN_CHECK_INTERVAL) {
      lastTokenCheck = now;
      logDebug('Window focus → checking FCM registration token');
      ensureFcmToken();
    }
  });

  // Service Worker update
  if (navigator.serviceWorker) {
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      logDebug('Service Worker updated → checking FCM registration token');
      ensureFcmToken();
    });
  }
};

export { initializeFcmLifecycleManager };
